// tslint:disable: quotemark
export enum ActivationEnum {
	User = 0,
	UtilityProvider = 1
}

export namespace ActivationEnum {
	export function toDescription(val: ActivationEnum) {
		switch (val) {
			case 0:
				return "User";
			case 1:
				return "Utility Provider";
		}
		return null;
	}
}
